import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.datasourceUsers;

const DatasourceUsersData = createSelector([selector], (state) => state);

export default {
  DatasourceUsersData
};
